module.exports = __webpack_public_path__ + "static/media/diksha.04316143.jfif";